import { useAssetListFilter, useSetAssetListFilter } from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { colors as CropCircleColors } from '../crop-circle/tokens';
import { DebouncedTextInput } from '../forms';

export const AssetSearchInput = () => {
  const { t } = useTranslation();
  const { data: assetFilter } = useAssetListFilter();
  const { mutateAsync } = useSetAssetListFilter();

  const [text, setText] = useState('');

  useEffect(() => {
    if (!text && assetFilter?.keyword) {
      setText(assetFilter.keyword);
    }
  }, [assetFilter]);

  const updateSearch = async (keyword: string) => {
    assetFilter.keyword = keyword;
    await mutateAsync(assetFilter);
  };

  return (
    assetFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceLength={1}
        debounceFunc={updateSearch}
        placeholder={t('assets.filter.searchPlaceholder')}
        value={text}
        onBlur={() => {}}
        onChangeText={(text) => setText(text)}
        height={32}
        width={'100%'}
        outlineStyle={styles.inputStyle}
        disableInnerStyle={true}
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: CropCircleColors.neutral[200],
    borderWidth: 0,
    borderRadius: 8,
  },
});
